class EventCountdown extends HTMLElement {
  constructor() {
      super();
      this.contentContainer = this.querySelector('.event-countdown-content-container');
      this.contentButton = this.querySelector('.event-countdown-content-more-button');
      this.contentItems = this.contentContainer.querySelectorAll('.event-countdown-content-item');
      this.firstItem = this.contentItems[0];
  }

  connectedCallback() {
      if (window.matchMedia('(max-width: 750px)').matches) {
          this.firstItem.addEventListener('click', this.slideDownItem.bind(this));
          this.contentButton.addEventListener('click', this.slideDownItem.bind(this));
      }
  }

  slideDownItem() {
      this.contentContainer.setAttribute('aria-expanded', 'true');
      this.contentButton.setAttribute('aria-expanded', 'true');
      $(this.contentItems).slideDown();
  }

}

customElements.define('event-countdown', EventCountdown);
